<template>
  <div style="max-width: 95%; margin: 0 auto; text-align: center;">
    <h5>审批管理</h5>

    <!-- 学期选择 -->
    <el-select v-model="selectedSemester" placeholder="请选择学期" style="width: 200px; margin: 10px;">
      <el-option
        v-for="(s, index) in semesters"
        :key="s.uuid"
        :label="s.name"
        :value="s.uuid"
      >
        <template #default>
          <span>{{ s.name }}</span>
          <el-tag v-if="index===0" type="primary" size="small" style="margin-left: 8px;">当前学期</el-tag>
        </template>
      </el-option>
    </el-select>

    <el-button type="primary" @click="fetchRequests" :loading="loadingRequests" style="margin-left: 10px;">
      查询
    </el-button>

    <!-- 审批表格 -->
    <el-table :data="requests" v-loading="loadingRequests" border style="width: 100%; margin-top: 20px;">
      <el-table-column prop="name" label="名称" min-width="180"/>
      <el-table-column prop="user" label="申请人" min-width="180"/>
      <el-table-column prop="Awardtype" label="获奖类型" width="120"/>
      <el-table-column prop="template_name" label="模板" width="150"/>
      <el-table-column prop="updatetime" label="更新时间" width="180"/>
      <el-table-column prop="state_text" label="状态" width="120">
        <template #default="{ row }">
          <span :style="{ color: row.state === '1' ? 'blue' : row.state === '2' ? 'green' : 'red', fontWeight: 'bold' }">
            {{ row.state === '1' ? '等待审批' : row.state === '2' ? '审批通过' : '审批不通过' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="{ row }">
          <el-button v-if="row.state === '1'" size="small" type="warning" @click="reviewRequest(row)">
            审批
          </el-button>
          <el-button v-else size="small" type="info" @click="viewDetails(row.uuid)">
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 审批弹窗 -->
    <el-dialog v-model="reviewDialogVisible" title="审批详情" width="80%">
      <el-table :data="detailData" border style="width: 100%;">
        <el-table-column prop="winner" label="获奖者"/>
        <el-table-column prop="class" label="班级"/>
        <el-table-column prop="AwardName" label="奖项名称"/>
        <el-table-column prop="GradeName" label="奖项等级"/>
        <el-table-column prop="mentor" label="指导老师"/>
      </el-table>
      <template #footer>
        <el-button @click="reviewDialogVisible = false">取消</el-button>
        <el-button type="success" @click="submitReview('2')">通过</el-button>
        <el-button type="danger" @click="submitReview('3')">不通过</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  data() {
    return {
      semesters: [],
      selectedSemester: null,
      requests: [],
      loadingRequests: false,
      reviewDialogVisible: false,
      detailData: [],
      currentUuid: null,
    };
  },
  mounted() {
    this.fetchSemesters();
  },
  methods: {
    async fetchSemesters() {
      try {
        const res = await axios.get("/api/semesters");
        this.semesters = res.data.semesters;
        if (this.semesters.length > 0) this.selectedSemester = this.semesters[0].uuid;
      } catch {
        ElMessage.error("获取学期失败");
      }
    },
    async fetchRequests() {
      if (!this.selectedSemester) {
        ElMessage.warning("请选择学期");
        return;
      }
      this.loadingRequests = true;
      try {
        const res = await axios.get("/api/approvalrequests", { params: { term: this.selectedSemester } });
        this.requests = res.data.requests.filter(r => ['1','2','3'].includes(r.state));
      } catch {
        ElMessage.error("获取审批请求失败");
      } finally {
        this.loadingRequests = false;
      }
    },
    async viewDetails(uuid) {
      try {
        const res = await axios.get(`/api/waitingr/${uuid}`);
        this.detailData = res.data.details;
        this.reviewDialogVisible = true;
        this.currentUuid = uuid;
      } catch {
        ElMessage.error("查询详情失败");
      }
    },
    reviewRequest(row) {
      this.currentUuid = row.uuid;
      this.viewDetails(row.uuid);
    },
    async submitReview(state) {
      try {
        let reply = null;
        if (state === '3') {
          // 驳回需要填写理由
          const { value } = await ElMessageBox.prompt('请输入驳回原因：', '审批驳回', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPlaceholder: '请输入原因',
            inputType: 'textarea',
          });
          reply = value;
          await ElMessageBox.confirm('确定要驳回该申请吗？', '确认驳回', { type: 'warning' });
        } else {
          await ElMessageBox.confirm('确定要通过该申请吗？', '确认通过', { type: 'warning' });
        }

        await axios.post("/api/approvalrequests/review", { uuid: this.currentUuid, state, reply });
        ElMessage.success(state === '2' ? '审批通过' : '审批不通过');
        this.reviewDialogVisible = false;
        this.fetchRequests();
      } catch (err) {
        if (err !== 'cancel') {
          ElMessage.error("提交审批失败");
        }
      }
    }
  }
};
</script>

<style scoped>
.el-table th, .el-table td {
  text-align: center !important;
  vertical-align: middle !important;
}
</style>
